export default __webpack_public_path__ + "static/media/ic-PreviewRsvp.c568ea3c.png";